export const SET_SEARCH = 'SET_SEARCH';
export const SEARCH_WHEN = 'SEARCH_WHEN';
export const SEARCH_WHERE = 'SEARCH_WHERE';
export const SEARCH_MORE_DAYS = 'SEARCH_MORE_DAYS';
export const SET_TRAVELLERS = 'SET_TRAVELLERS';
export const SET_SEARCH_DESTINY = 'SET_SEARCH_DESTINY';
